import { BigDataSolutionForOnlineBank } from '@components/cases/BigDataSolutionForOnlineBank'
import { CustomHead } from '@ui/sections/CustomHead'

function BigDataSolutionForOnlineBankPage() {
  return (
    <>
      <CustomHead
        title="Big Data Solution for Leading Eastern European Online Bank | Modsen"
        description="Discover the power of data-driven decision-making in banking with the Big Data solution that helped our client increase revenue by $2 million. Let Modsen show you how."
        imagePath="/images/custom-head/big-data-solution-for-online-bank.webp"
      />
      <BigDataSolutionForOnlineBank />
    </>
  )
}

export default BigDataSolutionForOnlineBankPage
